// extracted by mini-css-extract-plugin
export var messageSideLeft = "_op-1";
export var stateContainer = "_op-0";